import React, { useEffect } from "react";
import { entityChangeCache, sessionCache } from "modules/auth/cache";
import { useChangeNiasEntity } from "modules/auth/hooks/authHooks";
import { signInDone, signInError, signInRequest } from "modules/auth/store";
import { completeSignIn } from "modules/auth/utils";
import { useLocalStorageState } from "modules/common/hooks/useStorageState";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { parseChangeNiasEntityRequestFromRoute } from "services";
import { AppDispatch, RootState } from "store";
import { getInLieuOib } from "helpers/RedirectHelper";

export const CHANGE_NIAS_ENTITY_ROUTE_START = "/nias/entity/";
interface Props {}
export const NiasEntityChange: React.FC<Props> = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state: RootState) => state.signIn);
    const change = useChangeNiasEntity();
    const [key, setKey] = useLocalStorageState<string | undefined>("change-key");

    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const currentPath = location.pathname;
        const isChangeRoute = currentPath.startsWith(CHANGE_NIAS_ENTITY_ROUTE_START);
        if (!user) {
            const session = sessionCache().getSession();
            if (!session) {
                setKey(undefined);
                if (isChangeRoute) history.push("/");
                return;
            }
        }

        if (!isChangeRoute) return;

        history.push("/");
        const path = currentPath.substring(CHANGE_NIAS_ENTITY_ROUTE_START.length);
        const changeRequest = parseChangeNiasEntityRequestFromRoute(path);

        const keys = Object.keys(changeRequest);
        if (!keys.length) return;

        const inLieuOib = getInLieuOib(changeRequest);
        if (key === inLieuOib) return;
        setKey(inLieuOib);

        const entityChange = entityChangeCache();
        entityChange.save(false, changeRequest);
        dispatch(signInRequest());
        change
            .mutateAsync(changeRequest)
            .then(response => {
                if (response.accessToken)
                    completeSignIn(
                        dispatch as AppDispatch,
                        response.accessToken,
                        response.refreshToken
                    );
                else dispatch(signInDone());
            })
            .catch(() => {
                entityChange.save(true, changeRequest);
                dispatch(signInError({ errorMessage: "Promjena subjekta nije uspjela" }));
            });
    }, [location, history, user, key]);

    return null;
};
